/**
 * A path to come back to after signing in, such as a join link opened while
 * signed out. Google sign-in leaves the page, so it is kept in sessionStorage.
 */
const KEY = "luckymenu.returnTo";

export function rememberReturnTo(path: string): void {
	try {
		sessionStorage.setItem(KEY, path);
	} catch {
		// Private mode without storage: the person opens the link again.
	}
}

export function takeReturnTo(): string | null {
	try {
		const path = sessionStorage.getItem(KEY);
		sessionStorage.removeItem(KEY);
		return path?.startsWith("/join") ? path : null;
	} catch {
		return null;
	}
}
